export const SET_WINDOW_SIZE = "setWindowSize";
export const SET_NO_ERROR = "setNoError";
export const SWITCH_SHOW_HISTORY = "SWITCH_SHOW_HISTORY";
export const SWITCH_SHOW_ARCHIVE = "SWITCH_SHOW_ARCHIVE";
export const SWITCH_SHOW_MESSAGES = "SWITCH_SHOW_MESSAGES";
export const SET_CONFIRMATION_DIALOG = "SET_CONFIRMATION_DIALOG";

export const EDIT_CARD = "editCard";
export const EDIT_LIST = "editList";
